import { useSearchParams } from 'next/navigation';

import { QF_SEARCH_PARAMS } from '@/features/quickFindFilters/searchParams';
import { selectQuickFindLinkById } from '@/features/quickFindFilters/selectors';
import { useAppSelector } from '@/store';

export const useQFActiveLink = () => {
  const searchParams = useSearchParams();
  const quickFindID = searchParams.get(QF_SEARCH_PARAMS.quickFindID);

  const activeQFLink = useAppSelector((state) => selectQuickFindLinkById(state, quickFindID));

  return activeQFLink;
};
